module.exports = __webpack_public_path__ + "static/media/cloud3@2x.e08c0d0f.png";


//////////////////
// WEBPACK FOOTER
// ./src/Kiosk/AttractLoopView/cloud3@2x.png
// module id = 869
// module chunks = 0